import { ItineraryEvent, ItineraryEventType } from 'core/graphql/types';
import { useMemo } from 'react';

type EventsPolyline = {
  eventsPolyline: GeoJSON.Feature<GeoJSON.Geometry>;
};

const useEventsPolyline = (events: ItineraryEvent[]): EventsPolyline => {
  const eventsCoordinates = useMemo(
    () =>
      events
        .filter(
          (x) =>
            x.longitude !== null &&
            x.longitude !== undefined &&
            x.latitude !== undefined &&
            x.longitude !== null &&
            x.eventType === ItineraryEventType.Delivery,
        )
        .map((x) => [x.longitude!, x.latitude!]),
    [events],
  );

  const eventsPolyline: GeoJSON.Feature<GeoJSON.Geometry> = {
    id: 'route',
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'LineString',
      coordinates: eventsCoordinates,
    },
  };

  return { eventsPolyline };
};

export default useEventsPolyline;
